import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import ChatMessageBubble from '../ChatMessageBubble/ChatMessageBubble';
import Button from '../Button';

const SupportWelcomeMessage = ({ onScheduleDemo, name, isBasicUser }) => {
  const { t } = useTranslation('components');

  return (
    <ChatMessageBubble className="bg-white shadow-md">
      <div className="flex flex-col">
        <h3 className="mb-4">
          <Trans t={t} i18nKey="SupportWelcomeMessage.title" values={{ name }} />
        </h3>
        {isBasicUser ? (
          <>
            <div className="mb-4">
              <Trans
                t={t}
                i18nKey="SupportWelcomeMessage.free_info"
                components={{ break: <br /> }}
              />
            </div>
            <Button className="block mb-4" onClick={onScheduleDemo}>
              <Trans t={t} i18nKey="SupportWelcomeMessage.button" />
            </Button>
            <div className="mb-4">
              <Trans t={t} i18nKey="SupportWelcomeMessage.support_info" />
            </div>
          </>
        ) : (
          <div className="mb-4">
            <Trans t={t} i18nKey="SupportWelcomeMessage.paid_info" />
          </div>
        )}
        <div>
          <Trans t={t} i18nKey="SupportWelcomeMessage.greeting" components={{ break: <br /> }} />
        </div>
      </div>
    </ChatMessageBubble>
  );
};

SupportWelcomeMessage.defaultProps = {
  onScheduleDemo: () => {},
};

SupportWelcomeMessage.propTypes = {
  onScheduleDemo: PropTypes.func,
  name: PropTypes.string,
  isBasicUser: PropTypes.bool.isRequired,
};

export default SupportWelcomeMessage;
